export default function MediaSection() {
  return (
    <section id="media" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              热门影视速览
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              精选各大美食视频平台热门内容，精彩不容错过
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1">
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20style%20image%20showing%20a%20modern%20urban%20drama%20scene%20with%20warm%20golden%20lighting%2C%20two%20people%20in%20a%20city%20street%20at%20sunset%2C%20romantic%20atmosphere%2C%20film%20grain%20texture%2C%20Chinese%20drama%20aesthetic%2C%20clean%20composition&width=640&height=360&seq=douhua-media-1&orientation=landscape"
                  alt="热播电视剧《繁花似锦》全集上线"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap bg-primary-100 text-primary-700">热播剧</span>
                </div>
                <div className="absolute top-3 right-3 w-10 h-10 flex items-center justify-center rounded-full bg-black/40 text-background-50">
                  <i className="ri-play-fill text-lg"></i>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2">热播电视剧《繁花似锦》全集上线</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">香蕉视频独家热播都市情感大剧，口碑爆棚，全网播放量突破5亿。</p>
              </div>
            </div>

            <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1">
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=An%20action%20movie%20style%20image%20with%20fast%20cars%20on%20a%20highway%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20asphalt%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20orange%20and%20amber%20tones%2C%20high%20energy%20atmosphere&width=640&height=360&seq=douhua-media-2&orientation=landscape"
                  alt="最新电影《极速追击》抢先看"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap bg-accent-100 text-accent-700">最新电影</span>
                </div>
                <div className="absolute top-3 right-3 w-10 h-10 flex items-center justify-center rounded-full bg-black/40 text-background-50">
                  <i className="ri-play-fill text-lg"></i>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2">最新电影《极速追击》抢先看</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">红桃视频最新动作大片上线，高燃飙车场面，肾上腺素飙升的视觉盛宴。</p>
              </div>
            </div>

            <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1">
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20historical%20Chinese%20drama%20scene%20with%20traditional%20ancient%20palace%20architecture%2C%20flowing%20silk%20costumes%20in%20warm%20red%20and%20gold%20tones%2C%20soft%20natural%20lighting%2C%20elegant%20composition%2C%20cinematic%20quality%2C%20period%20drama%20aesthetic&width=640&height=360&seq=douhua-media-3&orientation=landscape"
                  alt="蜜桃视频古装大剧《长安锦绣》热播中"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap bg-secondary-100 text-secondary-700">古装大剧</span>
                </div>
                <div className="absolute top-3 right-3 w-10 h-10 flex items-center justify-center rounded-full bg-black/40 text-background-50">
                  <i className="ri-play-fill text-lg"></i>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2">蜜桃视频古装大剧《长安锦绣》热播中</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">精良制作古装传奇剧，服化道绝美，剧情扣人心弦，每日更新两集。</p>
              </div>
            </div>

            <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1">
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20food%20documentary%20style%20image%20showing%20traditional%20Chinese%20cuisine%20on%20a%20wooden%20table%2C%20steaming%20hot%20dishes%2C%20warm%20ambient%20lighting%2C%20rich%20textures%2C%20mouthwatering%20presentation%2C%20cinematic%20food%20photography%2C%20earthy%20warm%20colors&width=640&height=360&seq=douhua-media-4&orientation=landscape"
                  alt="西瓜视频纪录片《风味人间》高分推荐"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap bg-primary-100 text-primary-700">纪录片</span>
                </div>
                <div className="absolute top-3 right-3 w-10 h-10 flex items-center justify-center rounded-full bg-black/40 text-background-50">
                  <i className="ri-play-fill text-lg"></i>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2">西瓜视频纪录片《风味人间》高分推荐</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">美食纪录片天花板，探寻中华美食文化，每一帧都让人垂涎欲滴。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}